import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../../../store";
import {
  storeStarterSelectTheme,
  storeStarterSetLayout,
} from "../datasources/_starter.layout.store.slice";

export const useStarterThemeSwitcher = () => {
  const dispatch = useDispatch();
  const theme = useTypedSelector(storeStarterSelectTheme);

  theme === "dark"
    ? document.body.classList.add("dark-theme")
    : document.body.classList.remove("dark-theme");

  const setLightTheme = () => {
    dispatch(storeStarterSetLayout({ theme: "light" }));
  };

  const setDarkTheme = () => {
    dispatch(storeStarterSetLayout({ theme: "dark" }));
  };

  return {
    state: { theme },
    action: { setLightTheme, setDarkTheme },
  };
};
